import script from "./PathsMixin.vue?vue&type=script&lang=js"
export * from "./PathsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__